<template>
  <div class="curriculumDetails">
    <div class="media">
      <div class="title">
        {{ viewTitle }}
        <!-- <el-button v-if="currentPlayStatus" @click="onPlayerEnded" size="mini" style="position: absolute;right: 4px;top: 4px;">已学完此课程</el-button> -->
      </div>
      <!-- <div class="title2">（温馨提示：非直播视频学员需要点击暂停键才能断点续播）</div> -->
      <!-- <video-player
      v-if="videos.length || lives.length"-->
      <video-player
        class="video-player vjs-custom-skin"
        :class="{ aliving: activelives != null, 'alive-done': liveingDone }"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @playing="onPlayerPlaying($event)"
        @pause="onPlayerPause($event)"
        @timeupdate="timeupdate"
        @seeking="onPlayerSeeking"
        @seeked="onPlayerSeeked"
        @ended="onPlayerEnded"
      ></video-player>
    </div>
    <div class="media-list">
      <el-tabs v-model="activeTabsNames">
        <el-tab-pane label="简介" name="first">{{ description }}</el-tab-pane>
        <el-tab-pane label="课程目录" name="second">
          <div
            v-if="lives.length"
            style="margin-bottom: 20px; background: #f9f9f9; padding: 10px"
          >
            <p style="color: #677897; font-size: 16px; font-weight: bold">
              视频直播
              <span style="color: #f00; font-size: 9px">(*不计入学习进度)</span>
            </p>
            <div
              class="ailve-item"
              v-for="(i, _i) in lives"
              :key="_i"
              @click="viewIives(i, _i)"
              :class="{ active: activelives == _i }"
            >
              {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
              <div class="description">{{ i.aliveDate }}</div>
            </div>
          </div>

          <div v-if="videos.length" style="background: #f9f9f9; padding: 10px">
            <p style="color: #677897; font-size: 16px; font-weight: bold">
              视频课件
            </p>
            <div class="video-item" v-for="(i, _i) in videos" :key="_i">
              <div class="video-title">{{ _i + 1 }}.{{ i.title }}</div>
              <div
                class="video-item-list"
                v-for="(s, _s) in i.coursewares"
                :key="_s"
                :class="{
                  active:
                    s.id == activeVideo && s.sectionId == actvieVideoSections,
                }"
                @click="viewViedo(s)"
              >
                <div class="main-title">
                  <el-icon><VideoCameraFilled /></el-icon>
                  {{ s.title }}
                </div>
                <span class="timer">
                  {{ formatterData(s.vedio.timeLength) }}
                </span>
                <p style="clear: both; font-size: 12px; line-height: 20px">
                  学习进度：{{
                    s.currentTime
                      ? "（" +
                        (
                          (s.currentTime / s.vedio.timeLength > 1
                            ? 1
                            : s.currentTime / s.vedio.timeLength) * 100
                        ).toFixed(2) +
                        "%）"
                      : isCoursewareDone(s) ? "（100%）" : ""
                  }}{{ isCoursewareDone(s) ? "已完成" : "未完成" }}
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="视频直播" name="third" v-if="lives.length">
          <div
            class="ailve-item"
            v-for="(i, _i) in lives"
            :key="_i"
            @click="viewIives(i, _i)"
            :class="{ active: i.living }"
          >
            {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
            <div class="description">{{ i.aliveDate }}</div>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { VideoCameraFilled } from "@element-plus/icons-vue";
let VideocurrentTime = 0;
export default {
  name: "curriculum",
  components: { VideoCameraFilled },
  data() {
    return {
      videoId: "",
      httpsLocation: "https://tecsf.gdcoh.com",
      activePanesNames: [0],
      activeTabsNames: "second",
      viewTitle: "",
      description: "",
      videos: [],
      videoType: "",
      activeVideo: "",
      actvieVideoSections: 0,
      lives: [],
      activelives: "",
      liveingDone: false,
      currentPlayStatus: false,
      currentPlayTimer: 0,
      lastProgressReportValue: 0,
      lastProgressReportTime: 0,
      progressIncrementThreshold: 5,
      progressReportThrottleMs: 30000,
      // 课件完成判定相关：达到该比例后尝试触发一次“完成”上报，由后端统一校验
      coursewareCompleteThreshold: 0.8,
      hasTriedCompleteOnce: false,
      // 课件进度上报节流
      lastCoursewareProgressReportTime: 0,
      coursewareProgressThrottleMs: 10000,
      // 完成状态上报重试机制
      completionRetryCount: 0,
      maxCompletionRetries: 3,
      completionRetryDelayMs: 2000,
      pendingCompletionReport: null, // 待重试的完成状态上报
      initialDoneVideoIds: new Set(), // 记录初始化时接口返回的已完成视频ID，这些视频不需要再次调用done接口
      lastValidPlaybackTime: 0,
      seekingBlocked: false,
      seekRestoreTimer: null,
      lastSeekWarningAt: 0,
      tabLockId: "",
      lockStorageKey: "",
      lockHeartbeatTimer: null,
      lockHeartbeatMs: 10000,
      lockExpireMs: 60000,
      hasCourseLock: false,
      lockBlocked: false,
      lockListenerBound: false,
      playerOptions: {
        //播放速度
        playbackRates: [],
        //如果true,浏览器准备好时开始回放。
        autoplay: true,
        // 默认情况下将会消除任何音频·。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [],
        //你的封面地址
        // poster:
        // "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F1812.img.pp.sohu.com.cn%2Fimages%2Fblog%2F2009%2F11%2F18%2F18%2F8%2F125b6560a6ag214.jpg&refer=http%3A%2F%2F1812.img.pp.sohu.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1624024420&t=606e426a40c26ff068470eabe257afab",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
      },
    };
  },
  created() {
    this.videoId = this.$route.query && this.$route.query.id;
    this.cleanOtherUsersCache(); // 清理其他用户的缓存
    // 已取消单窗口限制，直接初始化数据
    this.initData();
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.seekRestoreTimer) {
      clearTimeout(this.seekRestoreTimer);
      this.seekRestoreTimer = null;
    }
    // 已取消单窗口限制，直接保存进度
    this.flushProgress(true);
  },
  methods: {
    isCoursewareDone(courseware) {
      return !!(courseware && (courseware.isDone === true || courseware.done === true));
    },
    // 清理其他用户的缓存数据，节省localStorage空间
    cleanOtherUsersCache() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      if (!userInfo.userName) return;

      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只保留当前用户的缓存数据
      const currentUserCache = list.filter(
        (el) => el.userName === userInfo.userName
      );
      
      // 如果数据有变化才更新（避免不必要的写入）
      if (currentUserCache.length !== list.length) {
        this.$storage.setStorage([
          {
            key: "vidoDataList",
            value: currentUserCache,
          },
        ]);
      }
    },
    initializeCourseLock() {
      // 已取消单窗口限制，此方法不再执行任何操作
      // 保留方法定义以避免可能的调用错误
    },
    generateTabLockId() {
      return `${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
    },
    getCourseLockStorageKey() {
      const courseId = this.$route.query && this.$route.query.id;
      return courseId ? `course_tab_lock_${courseId}` : "";
    },
    parseLockPayload(value) {
      if (!value) return null;
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    getCurrentLockPayload() {
      if (!this.lockStorageKey || typeof window === "undefined") return null;
      return this.parseLockPayload(localStorage.getItem(this.lockStorageKey));
    },
    isLockExpired(payload) {
      if (!payload || !payload.timestamp) return true;
      return Date.now() - payload.timestamp > this.lockExpireMs;
    },
    writeLockPayload(payload) {
      if (!this.lockStorageKey || typeof window === "undefined") return;
      localStorage.setItem(this.lockStorageKey, JSON.stringify(payload));
    },
    acquireCourseLock(initial = false) {
      // 已取消单窗口限制，始终返回 true 表示获取成功
      return true;
    },
    startLockHeartbeat() {
      // 已取消单窗口限制，不再启动心跳机制
      // 清理可能存在的旧定时器
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    stopLockHeartbeat() {
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    releaseCourseLock(removeEntry = true) {
      // 已取消单窗口限制，仅清理可能存在的定时器
      this.stopLockHeartbeat();
    },
    handleLockStorageEvent(event) {
      // 已取消单窗口限制，不再处理锁相关事件
    },
    handleLockDenied() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    handleLockLost() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    ensureCourseLockActive() {
      // 已取消单窗口限制，始终返回 true 允许操作
      return true;
    },
    getActiveCourseware() {
      const section = this.videos.find(
        (el) => el.id == this.actvieVideoSections
      );
      if (!section) {
        return null;
      }
      return section.coursewares.find((item) => item.id == this.activeVideo) || null;
    },
    getActiveCoursewareDuration() {
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio) {
        return 0;
      }
      return Number(courseware.vedio.timeLength) || 0;
    },
    clampPlaybackTime(rawTime, { updateTracker = true } = {}) {
      const duration = this.getActiveCoursewareDuration();
      const numeric = Math.max(Number(rawTime) || 0, 0);
      const safeTime = duration ? Math.min(numeric, duration) : numeric;
      if (updateTracker && safeTime > this.lastValidPlaybackTime) {
        this.lastValidPlaybackTime = safeTime;
      }
      return safeTime;
    },
    getFractionFromTime(timeValue) {
      const duration = this.getActiveCoursewareDuration();
      if (!duration) {
        return 0;
      }
      const safeTime = Math.min(Math.max(Number(timeValue) || 0, 0), duration);
      return safeTime / duration;
    },
    calculateLearningProgress(includeCurrent = false, currentFraction = 0) {
      let completed = 0;
      let total = 0;
      this.videos.forEach((section) => {
        if (section.coursewares) {
          section.coursewares.forEach((courseware) => {
            total++;
            if (this.isCoursewareDone(courseware)) {
              completed += 1;
            } else if (
              includeCurrent &&
              this.activeVideo &&
              courseware.id == this.activeVideo
            ) {
              completed += Math.min(currentFraction, 1);
            }
          });
        }
      });
      if (!total) return 0;
      return Number(((completed / total) * 100).toFixed(2));
    },
    reportCourseProgress(progress, completed = false, force = false, retryCount = 0, currentTime = null) {
      const courseId = this.$route.query && this.$route.query.id;
      if (!courseId || !this.activeVideo) {
        return Promise.resolve();
      }
      if (!this.ensureCourseLockActive()) {
        return Promise.resolve();
      }
      const normalized = Math.min(100, Math.max(0, Number(progress) || 0));
      if (normalized <= this.lastProgressReportValue && !completed) {
        return Promise.resolve();
      }
      if (!completed && !force) {
        const now = Date.now();
        if (
          normalized - this.lastProgressReportValue <
            this.progressIncrementThreshold &&
          now - this.lastProgressReportTime < this.progressReportThrottleMs
        ) {
          return Promise.resolve();
        }
      }
      this.lastProgressReportTime = Date.now();
      if (normalized > this.lastProgressReportValue) {
        this.lastProgressReportValue = normalized;
      }
      const params = new URLSearchParams();
      params.append("progress", normalized.toString());
      params.append("completed", completed ? "true" : "false");
      // 如果是完成上报且有 currentTime，一并传递给后端（解决进度同步失败的问题）
      if (completed && currentTime != null && currentTime > 0) {
        params.append("currentTime", currentTime.toString());
      }
      const url = `/api/my/course/coursewareDone/${courseId}/${this.activeVideo}?${params.toString()}`;
      
      return this.$https.put(url)
        .then(() => {
          // 上报成功，重置重试计数
          if (completed) {
            this.completionRetryCount = 0;
            this.pendingCompletionReport = null;
          }
        })
        .catch((error) => {
          // 如果是完成状态上报失败，且未超过最大重试次数，则重试
          if (completed && retryCount < this.maxCompletionRetries) {
            const delay = this.completionRetryDelayMs * Math.pow(2, retryCount); // 指数退避
            this.pendingCompletionReport = {
              progress: normalized,
              retryCount: retryCount + 1,
              currentTime: currentTime,
              delay: delay
            };
            console.warn(`[课件完成上报] 失败，${delay}ms 后重试 (${retryCount + 1}/${this.maxCompletionRetries}):`, error);
            setTimeout(() => {
              if (this.pendingCompletionReport) {
                this.reportCourseProgress(
                  this.pendingCompletionReport.progress,
                  true,
                  true,
                  this.pendingCompletionReport.retryCount,
                  this.pendingCompletionReport.currentTime
                );
              }
            }, delay);
          } else if (completed && retryCount >= this.maxCompletionRetries) {
            // 超过最大重试次数，记录到本地，等待页面加载时修复
            console.error(`[课件完成上报] 超过最大重试次数，将在页面加载时自动修复`);
            this.pendingCompletionReport = {
              progress: normalized,
              retryCount: retryCount,
              currentTime: currentTime,
              delay: 0
            };
          }
          // 非完成状态的上报失败，静默忽略（不影响用户体验）
        });
    },
    maybeReportProgress(currentTime, isNormalized = false) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio || !courseware.vedio.timeLength) {
        return;
      }
      const safeTime = isNormalized
        ? this.clampPlaybackTime(currentTime, { updateTracker: false })
        : this.clampPlaybackTime(currentTime);
      const fraction = this.getFractionFromTime(safeTime);
      const progress = this.calculateLearningProgress(true, fraction);
      this.reportCourseProgress(progress, false);
    },
    flushProgress(force = false) {
      if (!this.ensureCourseLockActive()) {
        return Promise.resolve();
      }
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio || !courseware.vedio.timeLength) {
        return Promise.resolve();
      }
      const safeTime = this.clampPlaybackTime(this.lastValidPlaybackTime, {
        updateTracker: false,
      });
      const fraction = this.getFractionFromTime(safeTime);
      const progress = this.calculateLearningProgress(true, fraction);
      
      // 如果达到完成阈值但未标记为完成，尝试上报完成状态
      const duration = this.getActiveCoursewareDuration();
      const shouldMarkComplete = duration && safeTime / duration >= this.coursewareCompleteThreshold;
      
      // 如果是完成上报，传递 currentTime 确保后端能获取最新进度
      return this.reportCourseProgress(progress, shouldMarkComplete, force, 0, shouldMarkComplete ? safeTime : null);
    },
    handleBeforeUnload() {
      if (this.ensureCourseLockActive()) {
        this.flushProgress(true);
      }
      this.releaseCourseLock();
    },
    timeupdate(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType != "liveing") {
        const rawTime = player.cache_.currentTime;
        const safeTime = this.clampPlaybackTime(rawTime);
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: safeTime || null,
          },
          () => {},
          true
        );
        if (!this.currentPlayTimer || !this.currentPlayStatus) {
          this.videos.forEach((el) => {
            if (el.id == this.actvieVideoSections) {
              el.coursewares.forEach((item) => {
                if (item.id == this.activeVideo && !this.isCoursewareDone(item)) {
                  this.currentPlayTimer = item.vedio.timeLength;
                  item.currentTime = safeTime;
                }
              });
            }
          });
          this.currentPlayStatus = this.currentPlayTimer
            ? safeTime / this.currentPlayTimer >= 1.0
            : false;
          if (this.currentPlayStatus) {
            this.onPlayerEnded();
          }
          VideocurrentTime = safeTime;
        }

        // 周期性向后端上报课件播放进度（单位：秒），用于统一的完成判定
        const now = Date.now();
        if (
          this.videoId &&
          this.activeVideo &&
          (!this.lastCoursewareProgressReportTime ||
            now - this.lastCoursewareProgressReportTime >=
              this.coursewareProgressThrottleMs)
        ) {
          this.lastCoursewareProgressReportTime = now;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${this.videoId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .catch(() => {});
        }

        // 当本课件已观看比例首次达到阈值时，尝试触发一次“完成”上报
        const duration = this.getActiveCoursewareDuration();
        if (
          duration &&
          !this.hasTriedCompleteOnce &&
          safeTime / duration >= this.coursewareCompleteThreshold
        ) {
          this.hasTriedCompleteOnce = true;
          // 先尝试同步当前进度到后端
          // 同时在完成上报中也传递 currentTime，作为双重保障
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${this.videoId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .finally(() => {
              // 无论进度上报成功与否，都尝试上报完成状态
              // 传递 currentTime 确保后端能获取最新进度（即使进度同步失败）
              const fraction = this.getFractionFromTime(safeTime);
              const progress = this.calculateLearningProgress(true, fraction);
              this.reportCourseProgress(progress, true, true, 0, safeTime);
            });
        }

        this.maybeReportProgress(safeTime, true);
      }
    },
    formatterData(time) {
      if (!time) {
        return "-";
      }
      const min = Math.floor(time % 3600); //分钟
      return (
        (Math.floor(time / 3600) ? Math.floor(time / 3600) + "时" : "") +
        (Math.floor(min / 60) ? Math.floor(min / 60) + "分" : "") +
        ((time % 60) + "秒")
      );
    },
    initData() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只获取当前用户的缓存数据
      const videoHistoryMap = {};
      list
        .filter((el) => el.userName === userInfo.userName)
        .map((el) => (videoHistoryMap[el.activeVideoID] = el.time));
      const id = this.$route.query && this.$route.query.id;
      this.$https
        .get("/api/my/course/details/" + id)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            let videoing = false;
            this.description = data.description;
            // 直播
            let _lives = data.lives.map((el) => {
              return {
                ...el,
                ...this.judeLives(res, el),
              };
            });
            this.lives = _lives
              .filter((el) => el.living)
              .concat(_lives.filter((el) => !el.living));
            this.lives.forEach((el, _el) => {
              if (el.living) {
                videoing = true;
                this.viewIives(el, _el);
              }
            });
            // 视频
            // 记录初始化时接口返回的已完成视频ID，这些视频不需要再次调用done接口
            const initialDoneVideoIds = new Set();
            data.coursewares.forEach((cw) => {
              if (this.isCoursewareDone(cw)) {
                initialDoneVideoIds.add(cw.id);
              }
            });
            this.initialDoneVideoIds = initialDoneVideoIds;
            
            this.videos = data.courseSections.map((el, _el) => {
              return {
                ...el,
                coursewares: data.coursewares
                  .filter((item) => item.sectionId == el.id)
                  .map((val, _val) => {
                    val.currentTime = videoHistoryMap[val.id];
                    if (!this.isCoursewareDone(val) && !videoing) {
                      videoing = true;
                      this.viewViedo(val);
                    }
                    return val;
                  }),
              };
            });
            if (!videoing) {
              data.courseSections.map((el, _el) => {
                data.coursewares
                  .filter((item) => item.sectionId == el.id)
                  .map((val, _val) => {
                    if (!_el) {
                      videoing = true;
                      this.viewViedo(val);
                    }
                  });
              });
            }
            // 兼容历史遗留数据：检查并修复已学完但未标记完成的课件
            this.fixHistoricalCoursewareProgress(data.coursewares, id);
          } else {
            this.$message.error(res.debug);
          }
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.debug ||
            error?.response?.data?.message ||
            error?.message ||
            "加载课程详情失败，请稍后重试";
          this.$message.error(msg);
        });
    },
    // 修复历史遗留数据：自动补传已完成但后台未标记的课件
    // 同时处理网络失败导致的上报失败情况
    fixHistoricalCoursewareProgress(coursewares, courseId) {
      if (!coursewares || !Array.isArray(coursewares) || !courseId) {
        return;
      }
      coursewares.forEach((courseware) => {
        // 检查条件：课件有视频时长，且播放进度达到完成阈值（80%），但后台未标记为完成
        if (
          courseware.vedio &&
          courseware.vedio.timeLength &&
          courseware.currentTime != null &&
          courseware.currentTime / courseware.vedio.timeLength >= this.coursewareCompleteThreshold &&
          !this.isCoursewareDone(courseware)
        ) {
          // 计算总学习进度：已完成的课程 + 当前课件（假设已完成）/全部课程*100
          let completedCourses = 0;
          let totalCourses = 0;
          coursewares.forEach((cw) => {
            totalCourses++;
            if (this.isCoursewareDone(cw) || (cw.id === courseware.id)) {
              completedCourses++;
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 为当前课件单独调用接口，补传completed=true
          // 传递 currentTime 确保后端能获取最新进度
          const params = new URLSearchParams();
          params.append("progress", learningProgress.toString());
          params.append("completed", "true");
          params.append("currentTime", (courseware.currentTime || courseware.vedio?.timeLength || 0).toString());
          const url = `/api/my/course/coursewareDone/${courseId}/${courseware.id}?${params.toString()}`;
          this.$https.put(url)
            .then(() => {
              console.log(`[自动修复] 课件 ${courseware.id} 完成状态已修复`);
            })
            .catch((error) => {
              console.warn(`[自动修复] 课件 ${courseware.id} 完成状态修复失败，将在下次页面加载时重试:`, error);
              // 失败时，依赖页面刷新时的再次检查
            });
        }
      });
    },
    // 播放回调
    onPlayerPlay() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        this.$refs.videoPlayer.player.currentTime(this.currentTime);
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
          },
          (list, listIndex) => {
            const resumeTime = list[listIndex].time || 0;
            const safeTime = this.clampPlaybackTime(resumeTime);
            this.$refs.videoPlayer.player.currentTime(safeTime);
          }
        );
      }
    },
    onPlayerPlaying() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (!this.playerPlaying) {
        this.playerPlaying = true;
        this.onPlayerPlay();
        // this.$refs.videoPlayer.player.currentTime(this.currentTime);
      }
    },
    // 暂停回调
    onPlayerPause(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      const safeTime = this.clampPlaybackTime(player.cache_.currentTime);
      this.setVidoData(
        {
          detailsID: this.videoId,
          activeVideoID: this.activeVideo,
          time: safeTime,
        },
        () => {},
        true
      );
      this.flushProgress(true);
    },
    onPlayerSeeking() {
      // 已取消单窗口限制，但保留快进检测机制
      if (this.videoType === "liveing") {
        return;
      }
      const playerInstance = this.$refs.videoPlayer?.player;
      if (!playerInstance) return;
      const requestedTime = playerInstance.currentTime();
      const tolerance = 0.5;
      if (requestedTime > this.lastValidPlaybackTime + tolerance) {
        this.seekingBlocked = true;
        const restoreTime = this.lastValidPlaybackTime;
        if (this.seekRestoreTimer) {
          clearTimeout(this.seekRestoreTimer);
        }
        this.seekRestoreTimer = setTimeout(() => {
          playerInstance.currentTime(restoreTime);
          this.seekRestoreTimer = null;
        }, 0);
        const now = Date.now();
        if (now - this.lastSeekWarningAt > 3000 && this.$message) {
          this.$message.warning("当前课程不支持快进");
          this.lastSeekWarningAt = now;
        }
      }
    },
    onPlayerSeeked() {
      if (this.seekingBlocked) {
        this.seekingBlocked = false;
      }
    },
    // 视频播完回调
    onPlayerEnded() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        let target = this.lives[this.activelives];
        let url =
          target.vedios.length > target.livingIndex + 1
            ? target.vedios[target.livingIndex + 1].url
            : "";
        target.livingIndex += 1;
        if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
        this.playerOptions.sources = [
          {
            type:
              (this.httpsLocation + url).indexOf(".m3u8") > 0
                ? "application/x-mpegURL"
                : "video/mp4",
            src: url ? this.httpsLocation + url : "",
          },
        ];
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: 0,
          },
          () => {},
          true
        );
        this.lastValidPlaybackTime = 0;
        let data = this.videos
          .find((el) => el.id == this.actvieVideoSections)
          .coursewares.find((el) => el.id == this.activeVideo);
        if (this.isCoursewareDone(data)) return;
        const learningProgress = this.calculateLearningProgress(true, 1);
        // 视频播放完成，传递完整的视频时长作为 currentTime
        const videoDuration = data.vedio?.timeLength || 0;
        this.reportCourseProgress(learningProgress, true, true, 0, videoDuration)
          .then(() => {
            // 以服务器为准：重新拉取课程详情，用服务端返回的 isDone 更新列表，只有成功落库才算“已完成”
            const id = this.$route.query && this.$route.query.id;
            if (id) {
              this.$https.get("/api/my/course/details/" + id).then((res) => {
                if (res.success && res.data && res.data.coursewares) {
                  const map = {};
                  res.data.coursewares.forEach((cw) => {
                    map[cw.id] = this.isCoursewareDone(cw);
                  });
                  this.videos.forEach((section) => {
                    (section.coursewares || []).forEach((cw) => {
                      if (Object.prototype.hasOwnProperty.call(map, cw.id)) {
                        cw.isDone = map[cw.id];
                        cw.done = map[cw.id];
                      }
                    });
                  });
                  this.$forceUpdate && this.$forceUpdate();
                }
              });
            }
          });
      }
    },
    // 直播
    viewIives(item, i) {
      this.playerPlaying = false;
      this.videoType = "liveing";
      if (!item.living) {
        this.$message({
          message: "尚未开始或已经结束",
          type: "warning",
        });
        return;
      }
      this.viewTitle = item.title;
      this.activelives = i;
      const url =
        item.vedios[item.livingIndex] && item.vedios[item.livingIndex].url;
      if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
      this.playerOptions.sources = [
        {
          type:
            (this.httpsLocation + url).indexOf(".m3u8") > 0
              ? "application/x-mpegURL"
              : "video/mp4",
          src: this.httpsLocation + item.vedios[item.livingIndex].url,
        },
      ];
      let currentTime =
        item.currentTime + (moment().valueOf() - item.ajaxTime) / 1000;
      setTimeout(() => {
        this.$refs.videoPlayer.player.currentTime(currentTime);
      }, 500);
      this.$https
        .put(
          "/api/my/course/liveRecord/" + this.$route.query.id + "/" + item.id
        )
        .then((res) => {
          console.log("liveRecord");
          console.log(res);
        })
        .catch((err) => {
          console.log("liveRecord");
          console.log(err);
        });
    },
    // 视频
    viewViedo(item) {
      // 已取消单窗口限制，不再检查锁状态
      this.playerPlaying = false;
      this.currentPlayTimer = 0;
      this.currentPlayStatus = false;
      this.hasTriedCompleteOnce = false;
      this.videoType = "video";
      this.activelives = null;
      this.viewTitle = item.title;
      this.actvieVideoSections = item.sectionId;
      this.activeVideo = item.id;
      // 如果本地状态是已看完，且不是初始化接口返回的已完成状态，切换时调用done接口，避免网络问题导致状态未同步
      // 参照移动端逻辑：如果初始化接口返回的数据中 isDone=true，说明后端已经确认完成，不需要再调用
      if (this.isCoursewareDone(item) && !this.initialDoneVideoIds.has(item.id)) {
        const courseId = this.$route.query && this.$route.query.id;
        if (courseId && item.id) {
          // 计算总学习进度
          let completedCourses = 0;
          let totalCourses = 0;
          this.videos.forEach((section) => {
            if (section.coursewares) {
              section.coursewares.forEach((courseware) => {
                totalCourses++;
                if (this.isCoursewareDone(courseware)) {
                  completedCourses++;
                }
              });
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 调用done接口，传递 currentTime 确保后端能获取最新进度
          const itemCurrentTime = item.currentTime || item.vedio?.timeLength || 0;
          this.$https
            .put(
              `/api/my/course/coursewareDone/${courseId}/${item.id}?progress=${learningProgress}&completed=true&currentTime=${itemCurrentTime}`
            )
            .catch(() => {
              // 静默失败，不影响用户体验
            });
        }
      }
      const resumeTime = item.currentTime || 0;
      const safeTime = this.clampPlaybackTime(resumeTime);
      this.lastValidPlaybackTime = safeTime;
      item.currentTime = safeTime;
      this.seekingBlocked = false;
      if (this.seekRestoreTimer) {
        clearTimeout(this.seekRestoreTimer);
        this.seekRestoreTimer = null;
      }
      this.playerOptions.sources = [
        {
          type: "video/mp4",
          src: this.httpsLocation + item.vedio.url,
        },
      ];
    },
    // 判断是否有直播数据
    judeLives(res, item) {
      let isAlive = false;
      const startTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.startTime + ":00"
      ).valueOf();
      const endTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
      ).valueOf();
      let aliveDate;
      // 判断日期
      Object.keys(item.dateSettings).forEach((el) => {
        let target = item.dateSettings[el];
        if (target) {
          switch (el) {
            case "monthDays":
              if (target.includes(moment(parseInt(res.stime)).format("DD"))) {
                isAlive = true;
              }
              aliveDate =
                "每月" +
                target.map((el) => el + 1).join(",") +
                "号 " +
                item.startTime +
                " 开始";
              break;
            case "specDays":
              target = target.map((el) =>
                moment(parseInt(el)).format("YYYY-MM-DD")
              );
              if (
                target.includes(
                  moment(parseInt(res.stime)).format("YYYY-MM-DD")
                )
              ) {
                isAlive = true;
              }
              aliveDate = target.join(",") + " " + item.startTime + " 开始";
              break;
            case "weeklyDays":
              if (target.includes(moment(parseInt(res.stime)).day())) {
                isAlive = true;
              }
              aliveDate =
                "每周" +
                target.map((el) => getWeekDate(el)).join(",") +
                " " +
                item.startTime +
                " 开始";
              break;
          }
        }
      });
      // 判断时间
      if (isAlive) {
        if (!(res.stime >= startTime && res.stime <= endTime)) {
          isAlive = false;
        }
      }
      // 计算直播播放时间,直播开始时间减去当前服务器时间得到已经开始的时间
      let currentTime = (res.stime - startTime) / 1000;
      let _currentTime = 0;
      let timeLength = 0;
      let livingIndex = 0;
      if (isAlive) {
        for (let i = 0; i <= item.vedios.length; i++) {
          if (timeLength >= currentTime) {
            livingIndex = i;
            _currentTime =
              item.vedios[i - 1].timeLength - (timeLength - currentTime);
            break;
          }
          timeLength += item.vedios[i].timeLength;
        }
      }
      return {
        currentTime: _currentTime,
        living: isAlive,
        // living: true,
        livingIndex: livingIndex ? livingIndex - 1 : 0,
        aliveDate: aliveDate,
        stime: res.stime,
        ajaxTime: moment().valueOf(),
      };
    },
    setVidoData(options, callBack, isSet = false) {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      // 如果是直接不保存数据
      if (this.videoType == "liveing") {
        return false;
      }
      // 保存当前数据到本地（用于保存回显视频地址和位置）
      let list = this.$storage.getStorage("vidoDataList") || [];
      // 只查找当前用户的缓存记录
      let listIndex = list.findIndex(
        (p) =>
          Number(p.detailsID) === Number(options.detailsID) &&
          Number(p.activeVideoID) === Number(options.activeVideoID) &&
          userInfo.userName == p.userName
      );
      if (listIndex !== -1) {
        if (callBack) {
          callBack([...list], listIndex);
        }
        if (isSet) {
          list[listIndex] = {
            detailsID: Number(options.detailsID),
            activeVideoID: Number(options.activeVideoID),
            time: options.time != null ? options.time : list[listIndex].time,
            timeLength: options.timeLength || 0,
            userName: userInfo.userName,
          };
        }
      } else {
        list.push({
          detailsID: Number(options.detailsID),
          activeVideoID: Number(options.activeVideoID),
          time: options.time || 0,
          timeLength: options.timeLength || 0,
          userName: userInfo.userName,
        });
      }
      this.$storage.setStorage([
        {
          key: "vidoDataList",
          value: list,
        },
      ]);
    },
  },
};

function getWeekDate(date) {
  const list = [
    { name: "星期日", value: 0 },
    { name: "星期一", value: 1 },
    { name: "星期二", value: 2 },
    { name: "星期三", value: 3 },
    { name: "星期四", value: 4 },
    { name: "星期五", value: 5 },
    { name: "星期六", value: 6 },
  ];
  return list.find((el) => el.value == date).name;
}
</script>
<style lang="less">
.curriculumDetails {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
  // overflow: hidden;
  // overflow: hidden;
  .media {
    position: absolute;
    left: 0;
    right: 350px;
    top: 0;
    bottom: 0;
    border: 1px solid #e4e7ed;
    .title {
      color: #677897;
      font-size: 16px;
      font-weight: bold;
      padding: 10px;
      height: 36px;
    }
    .title2 {
      background: #d4d8df;
      text-align: center;
      color: #da2828;
      font-size: 16px;
      font-weight: bold;
      padding: 10px;
    }
    .vjs-progress-control {
      display: none !important;
    }
    .vjs-fullscreen-control {
      position: absolute;
      right: 0;
    }
    .aliving {
      .vjs-play-control {
        display: none !important;
      }
      .vjs-current-time {
        display: none !important;
      }
      .vjs-tech {
        pointer-events: none;
      }
      .timeout-lives {
        text-align: center;
      }
    }
  }
  .media-list {
    position: absolute;
    width: 350px;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0 20px;
    border-top: 1px solid #e4e7ed;
    font-size: 13px;
    overflow: auto;
    .video-item {
      cursor: pointer;
      line-height: 30px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      border-bottom: 1px solid #e4e7ed;
      font-weight: normal;
      color: #b0b9ca;
      .video-item-list {
        padding-left: 10px;
      }
      .main-title {
        width: 75%;
        float: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-wrap: break-word;
      }
      .timer {
        width: 25%;
        text-align: right;
        float: right;
      }
    }
    .ailve-item {
      cursor: pointer;
      line-height: 30px;
      border-bottom: 1px solid #e4e7ed;
      color: #b0b9ca;
      font-weight: bold;
      font-size: 14px;
      .description {
        font-size: 12px;
        font-weight: normal;
      }
    }
    .active {
      color: #0a73c5;
      .description {
        color: #677897;
      }
    }

    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__content {
      padding: 10px 0;
    }
    .el-tabs__item {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap,
    .el-collapse {
      border: none;
      color: #677897;
      font-weight: bold;
    }
  }
}
</style>
